import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

import promotionalBannersService from '../../services/promoBannersService';
import { showMsg } from '../../services/library';
import { FIRST_PHOTO, DEFAULT_DURATION, RESOLUTION_3x2, RESOLUTION_4x3 } from '../../constants/commonConst';
const REQ_FEATUREBANNERS = 'promotionalbanners/';

export const INITIAL_FILTER = {
  id: 0,
  Applyto: FIRST_PHOTO,
  selectedShots: null,
  New: false,
  Normal: false,
  VDS: false,
  Used: false,
  Prelim: false,
  CPO: false,
  photoOperator: null,
  photoValue: '',
  FromYear: null,
  ToYear: null,
  VIN: null,
  ExcludeMake: false,
  Make: null,
  ExcludeModel: false,
  Model: null,
  ExcludeTrim: false,
  Trim: null,
  MinPrice: '',
  MaxPrice: '',
  MinMileage: '',
  MaxMileage: '',
  ExcludeElectric: false,
  ageOperator: null,
  ageValue: '',
  stockOperator: null,
  stockValue: '',
  bannerId: null,
  bannerUrl: null,
  startDate: null,
  endDate: null,
  durationType: DEFAULT_DURATION,
  durationDays: '',
  applied: false,
  notApplied: false,
  replace: false
};

// Get templatelist and fontlist
export const fetchPromoBannersInfoReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}fetchAllDetails`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.getAllDetails(data);
      if (response?.status) {
        return response?.data[0] || null;
      } else {
        showMsg(response?.errors);
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// get banner history
export const getBannerHistoryReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}getBannerHistory`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.getBannerHistory(data);
      if (response?.status) {
        return response.data || null;
      } else {
        showMsg(response?.errors);
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// Get vehicle photos
export const getVehicleGalleryReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}getVehicleGallery`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.getVehicleGallery(data);
      if (response?.status) {
        return response.data[0] || null;
      } else {
        showMsg(response?.errors);
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// Add template
export const saveTemplateReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}saveTemplate`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.saveTemplate(data);
      if (response?.status) {
        return response?.data[0] || null;
      } else {
        showMsg(response?.errors);
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// Update template
export const updateTemplateReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}updateTemplate`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.updateTemplate(data);
      if (response?.status) {
        return response.data[0] || null;
      } else {
        showMsg(response?.errors);
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// Delete template
export const deleteTemplateReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}deleteTemplate`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.deleteTemplate(data);
      if (response?.status) {
        return response || null;
      } else {
        showMsg(response?.errors);
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// Update promo banner processing toggle
export const updateDealerPromoProcessReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}updateDealerPromoProcess`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.updateDealerPromoProcess(data);
      if (response?.status) {
        return response || null;
      } else {
        showMsg(response?.errors);
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// Reset banner process
export const resetBannerProcessReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}resetBannerProcess`,

  async (data, { rejectWithValue }) => {
    try {
      await promotionalBannersService.resetBannerProcess(data);
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// Apply banner
export const applyPromoBannerReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}applyPromoBanner`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.applyPromoBanner(data);
      return response;
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// Remove banner
export const removePromoBannerReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}removePromoBanner`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.removePromoBanner(data);
      return response;
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// Update promo banner processing toggle
export const saveFilterReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}saveFilter`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.saveFilter(data);
      if (response?.status) {
        return response || null;
      } else {
        showMsg(response?.errors);
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// Update promo banner processing toggle
export const deleteFilterReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}deleteFilter`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.deleteFilter(data);
      if (response?.status) {
        return { filterId: data?.filterId };
      } else {
        showMsg(response?.errors);
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

// Save Promo Banner Filter Priorities
export const saveFilterPrioritiesReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}saveFilterPriorities`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.saveFilterPriorities(data);
      if (response?.status) {
        showMsg(response.message, 'success');
        return { filterList: data.filterList };
      } else {
        showMsg(response?.errors);
      }
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

export const updateFilterNameReq = createAsyncThunk(
  `${REQ_FEATUREBANNERS}updateFilterName`,

  async (data, { rejectWithValue }) => {
    try {
      const response = await promotionalBannersService.updateFilterName(data);
      if (response?.status) {
        showMsg(response.message, 'success');
        return { data };
      } else {
        showMsg(response?.errors);
      }
    } catch (error) {
      showMsg(error);
      return rejectWithValue(error);
    }
  }
);

const bannerSettingsSlice = createSlice({
  name: 'PromotionalBanners',
  initialState: {
    activeTab: 'library',
    viewType: 'top',
    nameModalToggle: false,
    bannerRatio: { is43: false, resolution: RESOLUTION_3x2 },

    // Banner library
    overlayContent: [],
    activeBannerType: null,
    promoBannerList: [],
    selectedTemplate: null,
    tempName: '',
    fontList: [],
    isFontLoading: true,
    fontLibraryToggle: false,
    defaultImages: [],
    defaultImagesToggle: false,
    vin: '',
    previewToggle: false,
    previewUrl: null,

    // Apply banner
    filterModalToggle: false,
    vehLoaded: false,
    previewGalleryImage: null,
    invVehicles: [],
    filterTagList: [],
    vinList: [],
    yearList: [],
    makeList: [],
    modelList: [],
    trimList: [],
    filterName: '',
    filterList: [],
    currentFilter: INITIAL_FILTER,
    exportShots: [],
    dealerBannerProcessing: 0,
    bannerProgress: { status: false, value: 0 },

    // Banner history
    historyLoaded: [],
    bannerHistorydetails: [],
    historyStart: moment().add(-15, 'days').toDate(),
    historyEnd: moment().toDate()
  },

  reducers: {
    handleActiveTab: {
      reducer(state, action) {
        state.activeTab = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleViewType: {
      reducer(state, action) {
        state.viewType = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    // Banner library
    handleOverlayContent: {
      reducer(state, action) {
        state.overlayContent = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleActiveBannerType: {
      reducer(state, action) {
        state.activeBannerType = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handlePromoBannerList: {
      reducer(state, action) {
        state.promoBannerList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleSelectedTemplate: {
      reducer(state, action) {
        state.selectedTemplate = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleFontList: {
      reducer(state, action) {
        state.fontList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },

    handleIsFontLoading: {
      reducer(state, action) {
        state.isFontLoading = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleFontLibraryToggle: {
      reducer(state, action) {
        state.fontLibraryToggle = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleDefaultImages: {
      reducer(state, action) {
        state.defaultImages = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleDefaultImagesToggle: {
      reducer(state, action) {
        state.defaultImagesToggle = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleVin: {
      reducer(state, action) {
        state.vin = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handlePreviewToggle: {
      reducer(state, action) {
        state.previewToggle = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handlePreviewUrl: {
      reducer(state, action) {
        state.previewUrl = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleTempName: {
      reducer(state, action) {
        state.tempName = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleNameModalToggle: {
      reducer(state, action) {
        state.nameModalToggle = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },

    // Apply banner
    handleFilterModalToggle: {
      reducer(state, action) {
        state.filterModalToggle = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleVehLoaded: {
      reducer(state, action) {
        state.vehLoaded = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handlePreviewGalleryImage: {
      reducer(state, action) {
        state.previewGalleryImage = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleInvVehicles: {
      reducer(state, action) {
        state.invVehicles = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleFilterTagList: {
      reducer(state, action) {
        state.filterTagList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleVinList: {
      reducer(state, action) {
        state.vinList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleYearList: {
      reducer(state, action) {
        state.yearList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleMakeList: {
      reducer(state, action) {
        state.makeList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleModelList: {
      reducer(state, action) {
        state.modelList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleTrimList: {
      reducer(state, action) {
        state.trimList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleFilterName: {
      reducer(state, action) {
        state.filterName = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleFilterList: {
      reducer(state, action) {
        state.filterList = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleCurrentFilter: {
      reducer(state, action) {
        state.currentFilter = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleExportShots: {
      reducer(state, action) {
        state.exportShots = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleDealerBannerProcessing: {
      reducer(state, action) {
        state.dealerBannerProcessing = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleBannerProgress: {
      reducer(state, action) {
        state.bannerProgress = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleHistoryLoaded: {
      reducer(state, action) {
        state.historyLoaded = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleBannerHistorydetails: {
      reducer(state, action) {
        state.bannerHistorydetails = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleHistoryStart: {
      reducer(state, action) {
        state.historyStart = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleHistoryEnd: {
      reducer(state, action) {
        state.historyEnd = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    }
  },

  extraReducers: builder => {
    builder
      // #region fetchPromoBannersInfoReq
      .addCase(fetchPromoBannersInfoReq.pending, state => {
        state.isFontLoading = true;
        state.fontList = [];
      })
      .addCase(fetchPromoBannersInfoReq.fulfilled, (state, action) => {
        const {
          dealerIs43,
          promotionalBannerDetails,
          fontFileList,
          invVehiclesData,
          promobannerfilters,
          exportShots,
          defaultImages
        } = action.payload;

        // dealer ratio
        state.bannerRatio = { is43: dealerIs43, resolution: dealerIs43 ? RESOLUTION_4x3 : RESOLUTION_3x2 };
        const promoBannerList =
          promotionalBannerDetails?.map(d => ({
            ...d,
            label: d.pb_name,
            value: d.pb_id
          })) || [];

        // ------Library------
        state.promoBannerList = promoBannerList;
        state.isFontLoading = false;

        state.fontList =
          fontFileList?.map(d => ({
            ...d,
            label: d.vf_filename,
            value: d.vf_id
          })) || [];

        // state.selectedTemplateId = null;
        // state.tempName = '';

        // ------Apply banner------
        const detail = invVehiclesData.map(z => ({
          ...z,
          filtered: true,
          checked: false,
          isCollapsed: false
        }));
        state.invVehicles = detail;

        const createList = key =>
          [...new Set(invVehiclesData.map(d => d[key]))]
            .filter(Boolean)
            .sort((a, b) => a - b)
            .map(value => ({ value, label: value }));

        state.vinList = createList('inv_vin');
        state.yearList = createList('inv_year');
        state.makeList = createList('inv_make');
        state.modelList = createList('inv_model');
        state.trimList = createList('inv_trim');

        state.exportShots = exportShots;
        state.defaultImages = defaultImages;
        state.dealerBannerProcessing = detail.some(e => e.pl_processing_status === 1)
          ? 1
          : detail.some(e => e.pl_processing_status === 2)
          ? 2
          : 0;
        const filters = promobannerfilters.map(x => ({
          ...x,
          value: x.pf_id,
          label: x.pf_name
        }));
        state.filterList = filters;
      })
      .addCase(fetchPromoBannersInfoReq.rejected, state => {
        state.isFontLoading = false;
      })
      // #endregion
      // #region saveTemplateReq
      .addCase(saveTemplateReq.fulfilled, (state, action) => {
        const { tempObject, bannerDetails } = action.payload;
        tempObject.value = tempObject.pb_id;
        tempObject.label = tempObject.pb_name;
        tempObject.overlayArr = bannerDetails;
        const updatedList = [...state.promoBannerList, tempObject];
        state.promoBannerList = updatedList;
        state.tempName = '';
        state.selectedTemplate = tempObject || null;
        showMsg('Template added successfully', 'success');
      })
      // #endregion
      // #region updateTemplateReq
      .addCase(updateTemplateReq.fulfilled, (state, action) => {
        const { updatedIds = [], bannerDetails = [], reApplyExisting, is43 = false } = action.payload;
        const msgs = ['Template updated successfully.'];
        if (reApplyExisting) {
          msgs.push('Image reprocessing has started.');
        }
        showMsg(msgs, 'success');
        state.currentFilter = {
          ...state.currentFilter,
          bannerUrl:
            state.currentFilter.bannerUrl && state.currentFilter.bannerId
              ? `${
                  state.promoBannerList.find(d => d.value === state.currentFilter.bannerId)?.pb_imgurl
                }?ver=${Date.now()}`
              : null
        };
        const promobannerDetails = state?.promoBannerList?.map(d => {
          return {
            ...d,
            overlayArr: d.pb_id === state?.selectedTemplate?.value ? bannerDetails : d.overlayArr,
            pb_overlay_ids: d.pb_id === state?.selectedTemplate?.value ? updatedIds : d.pb_overlay_ids,
            pb_is43: d.pb_id === state?.selectedTemplate?.value ? is43 : d.pb_is43
          };
        });
        state.selectedTemplate = promobannerDetails.find(d => d.pb_id === state.selectedTemplate?.value);
        state.promoBannerList = promobannerDetails;
      })
      // #endregion
      // #region deleteTemplateReq
      .addCase(deleteTemplateReq.fulfilled, (state, action) => {
        const { message } = action.payload;
        state.promoBannerList = state?.promoBannerList.filter(d => d.value !== state.selectedTemplate?.value);
        if (state.currentFilter.bannerId === state.selectedTemplate?.value) {
          state.currentFilter = { ...state.currentFilter, bannerId: 0, bannerUrl: null };
        }
        state.selectedTemplate = null;
        showMsg(message, 'success');
      })
      // #endregion
      // #region deleteFilterReq
      .addCase(deleteFilterReq.fulfilled, (state, action) => {
        const { filterId } = action.payload;
        state.filterList = state?.filterList
          .filter(d => d.value !== filterId)
          .map((x, i) => ({ ...x, pf_order: i + 1 }));
        state.currentFilter = INITIAL_FILTER;
        showMsg('Filter deleted successfully', 'success');
      })
      // #endregion
      // #region deleteFilterReq
      .addCase(saveFilterPrioritiesReq.fulfilled, (state, action) => {
        const { filterList } = action.payload;
        state.filterList = filterList.map(x => ({ ...x, pf_order: x.order }));
      })
      // #endregion
      // #region updateFilterNameReq
      .addCase(updateFilterNameReq.fulfilled, (state, action) => {
        const data = action.payload?.data;
        if (data) {
          state.filterList = state.filterList.map(x => ({
            ...x,
            pf_name: x.pf_id === data.filterId ? data.filterName : x.pf_name,
            label: x.pf_id === data.filterId ? data.filterName : x.label
          }));
        }
      })
      // #endregion
      // #region getBannerHistoryReq
      .addCase(getBannerHistoryReq.pending, state => {
        state.historyLoaded = true;
        state.bannerHistorydetails = [];
      })
      .addCase(getBannerHistoryReq.fulfilled, (state, action) => {
        state.bannerHistorydetails = action.payload;
      })
      .addCase(getBannerHistoryReq.rejected, state => {
        state.historyLoaded = false;
      });
    // #endregion
  }
});

export const {
  handleActiveTab,
  handleViewType,

  // Banner library
  handleOverlayContent,
  handleActiveBannerType,
  handlePromoBannerList,
  handleSelectedTemplate,
  handleTempName,
  handleNameModalToggle,
  handleFontList,
  handleIsFontLoading,
  handleFontLibraryToggle,
  handleDefaultImages,
  handleDefaultImagesToggle,
  handleVin,
  handlePreviewToggle,
  handlePreviewUrl,

  // Apply banner
  handleFilterModalToggle,
  handleVehLoaded,
  handlePreviewGalleryImage,
  handleInvVehicles,
  handleFilterTagList,
  handleVinList,
  handleYearList,
  handleMakeList,
  handleModelList,
  handleTrimList,
  handleFilterName,
  handleFilterList,
  handleCurrentFilter,
  handleExportShots,
  handleDealerBannerProcessing,
  handleBannerProgress,
  handleHistoryLoaded,
  handleBannerHistorydetails,
  handleHistoryStart,
  handleHistoryEnd
} = bannerSettingsSlice.actions;

export default bannerSettingsSlice.reducer;
